import React from 'react'

//* Translations
import { TRANSLATIONS } from 'pages/Career/utilities';
import { getTranslation } from 'translations';

// Styles
import styles from './Section2.module.scss';

const CARD_IMG1 = "https://filotrack.com/wp-content/uploads/AboutUs_Work_life_balance-1.webp"
const CARD_IMG2 = "https://filotrack.com/wp-content/uploads/AboutUs_Location_Speciale_2023-1.webp"
const CARD_IMG3 = "https://filotrack.com/wp-content/uploads/AboutUs_Crescita_Professionale-1.webp"
const CARD_IMG4 = "https://filotrack.com/wp-content/uploads/AboutUs_Non_Solo_Lavoro_2023-1.webp"

const Section2 = () => {
    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase();
  return (
    <section className={styles["section2"]}>
      <h4 className={styles["title"]}>{getTranslation(TRANSLATIONS, LANG, "section2_title")}</h4>
      <div className={styles["cards-container"]}>
        <div className={styles["card"]}>
            <img src={CARD_IMG1} alt="card-img-1" className={styles["card-img"]} />
            <h5 className={styles["card-title"]}>{getTranslation(TRANSLATIONS, LANG, "section2_card1_title")}</h5>
            <p className={styles["card-description"]}>{getTranslation(TRANSLATIONS, LANG, "section2_card1_description")}</p>
        </div>
        <div className={styles["card"]}>
            <img src={CARD_IMG2} alt="card-img-2" className={styles["card-img"]} />
            <h5 className={styles["card-title"]}>{getTranslation(TRANSLATIONS, LANG, "section2_card2_title")}</h5>
            <p className={styles["card-description"]}>{getTranslation(TRANSLATIONS, LANG, "section2_card2_description")}</p>
        </div>
        <div className={styles["card"]}>
            <img src={CARD_IMG3} alt="card-img-3" className={styles["card-img"]} />
            <h5 className={styles["card-title"]}>{getTranslation(TRANSLATIONS, LANG, "section2_card3_title")}</h5>
            <p className={styles["card-description"]}>{getTranslation(TRANSLATIONS, LANG, "section2_card3_description")}</p>
        </div>
        <div className={styles["card"]}>
            <img src={CARD_IMG4} alt="card-img-4" className={styles["card-img"]} />
            <h5 className={styles["card-title"]}>{getTranslation(TRANSLATIONS, LANG, "section2_card4_title")}</h5>
            <p className={styles["card-description"]}>{getTranslation(TRANSLATIONS, LANG, "section2_card4_description")}</p>
        </div>
      </div>
    </section>
  )
}

export default Section2